import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/** <cadence-checkbox ?checked label="…"> emits `change` with boolean. */
@customElement('cadence-checkbox')
export class CadenceCheckbox extends LitElement {
  @property({ type: Boolean }) checked = false;
  @property() label = '';

  static styles = css`
    :host { display: inline-block; }
    label { display: inline-flex; align-items: center; gap: 8px; cursor: pointer; font-size: 0.9rem; color: var(--color-text-primary); }
    input { width: 16px; height: 16px; accent-color: var(--color-primary); cursor: pointer; }
  `;

  private onChange(e: Event) {
    e.stopPropagation();
    this.checked = (e.target as HTMLInputElement).checked;
    this.dispatchEvent(new CustomEvent('change', { detail: this.checked, bubbles: true, composed: true }));
  }

  render() {
    return html`<label><input type="checkbox" .checked=${this.checked} @change=${this.onChange} />${this.label ? html`<span>${this.label}</span>` : ''}</label>`;
  }
}
